var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.82 8 36 1.18A4 4 0 0 0 33.18 0H14a4 4 0 0 0 -4 4v2H8a4 4 0 0 0 -4 4v34a4 4 0 0 0 4 4h26a4 4 0 0 0 4 -4v-2h2a4 4 0 0 0 4 -4V10.82A4 4 0 0 0 42.82 8ZM34 43a1 1 0 0 1 -1 1h-24a1 1 0 0 1 -1 -1v-32a1 1 0 0 1 2 0V38a4 4 0 0 0 4 4h19a1 1 0 0 1 1 1Zm6 -6a1 1 0 0 1 -1 1h-24a1 1 0 0 1 -1 -1v-32a1 1 0 0 1 1 -1h17.76a0.94 0.94 0 0 1 0.7 0.3l6.24 6.24a0.94 0.94 0 0 1 0.3 0.7Z",
    fill: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.570803f7.svg";
export { ForwardRef as ReactComponent };